var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fas",class:{'fa-check text-success': _vm.model, 'fa-times text-danger': !_vm.model}})}
var staticRenderFns = []

export { render, staticRenderFns }